<script setup>
import FormInput from "../form/FormInput.vue";
import {inject, reactive, onMounted} from "vue";

const emitter = inject('emitter')

const searchInputs = reactive({
    name: '',
    salary: '',
    place: '',
})

const props = defineProps([
    'jobTranslations'
])

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const salary = urlParams.get('salary');

    if (salary && !isNaN(salary)) {
        searchInputs.salary = salary;
    }
})

function searchJobOffers(e) {
    e.preventDefault()
    const searchBox = document.querySelector('.job-finder__search-box')
    const inputs = searchBox.querySelectorAll('input')
    inputs.forEach(input => {
        searchInputs[input.name] = input.value
    })
    emitter.emit('setSearchParams', {
        name: searchInputs.name,
        salary: searchInputs.salary,
        place: searchInputs.place,
    })
    emitter.emit('searchJobOffers', {
        page: 1,
        name: searchInputs.name,
        salary: searchInputs.salary,
        place: searchInputs.place,
    })
}

</script>

<template>
    <div class="job-finder__search-box">
        <div class="wrapper">
            <FormInput
                type="text"
                :label="jobTranslations['Vyhľadávanie - názov (nápis)']"
                id="name"
                name="name"
                :placeholder="jobTranslations['Vyhľadávanie - názov (placeholder)']"
            />

            <FormInput
                type="number"
                :label="jobTranslations['Vyhľadávanie - plat (nápis)']"
                id="salary"
                name="salary"
                :value="searchInputs.salary"
                :placeholder="jobTranslations['Vyhľadávanie - plat (placeholder)']"
            />

            <FormInput
                type="text"
                :label="jobTranslations['Vyhľadávanie - miesto (nápis)']"
                id="place"
                name="place"
                :placeholder="jobTranslations['Vyhľadávanie - miesto (placeholder)']"
            />

            <div class="input-holder">
                <button type="submit" class="c-button c-button--primary" @click="searchJobOffers">
                    {{ jobTranslations['Vyhľadávanie - tlačidlo (nápis)'] }}
                    <svg width="17px" height="18px">
                        <use href="/img/icons/icons.svg#btnArrow"></use>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>
